module.exports = __webpack_public_path__ + "img/tarj2-3.39d0a3b5.svg";